import { createDynamicSlice } from ".";
import {
  ApproveOrderThunk,
  getSellerListingThunk,
  getStoresListingThunk,
  ChangeStatusInStoreThunk,
  OrderBarThunk,
  OrderChangeStatusThunk,
  OrderInStoreThunk,
  OrderOverviewThunk,
  OrderPaymentThunk,
  OrderRemarksHistoryThunk,
  OrderRevenueThunk,
  OrderShipmentHistoryThunk,
  OrderShippingThunk,
  OrderThunk,
  OrderTransactionThunk,
  PendingAmountThunk,
  PrintInvoiceThunk,
  PrintLabelThunk,
  SaveOrderRemarksThunk,
  SettlementThunk,
  WayuvegaThunk,
  GenerateManifestThunk,
  UploadBloodSampleReportThunk,
  getInvoicesByRefsThunk,
} from "../thunks/orderThunk";

const OrderSlice = createDynamicSlice({
  name: "OrderSlice",
  thunk: OrderThunk,
  listMode: true,
});

const OrderOverviewSlice = createDynamicSlice({
  name: "OrderOverviewSlice",
  thunk: OrderOverviewThunk,
});
const OrderTransactionSlice = createDynamicSlice({
  name: "OrderTransactionSlice",
  thunk: OrderTransactionThunk,
});
const OrderPaymentSlice = createDynamicSlice({
  name: "OrderPaymentSlice",
  thunk: OrderPaymentThunk,
});

const SaveOrderRemarksSlice = createDynamicSlice({
  name: "SaveOrderRemarksSlice",
  thunk: SaveOrderRemarksThunk,
  resetActionName: "resetSaveOrderRemark",
});

const OrderRemarksHistorySlice = createDynamicSlice({
  name: "OrderRemarksHistorySlice",
  thunk: OrderRemarksHistoryThunk,
});

const OrderInStoreSlice = createDynamicSlice({
  name: "OrderInStoreSlice",
  thunk: OrderInStoreThunk,
});

const OrderShippingSlice = createDynamicSlice({
  name: "OrderShippingSlice",
  thunk: OrderShippingThunk,
});

const ChangeStatusInStoreSlice = createDynamicSlice({
  name: "ChangeStatusInStoreSlice",
  thunk: ChangeStatusInStoreThunk,
  resetActionName: "resetChangeStatusInstore",
});

const OrderBarSlice = createDynamicSlice({
  name: "OrderBarSlice",
  thunk: OrderBarThunk,
});
const OrderChangeStatusSlice = createDynamicSlice({
  name: "OrderChangeStatusSlice",
  thunk: OrderChangeStatusThunk,
  resetActionName: "resetOrderChangeStatus",
});

const OrderShipmentHistorySlice = createDynamicSlice({
  name: "OrderShipmentHistorySlice",
  thunk: OrderShipmentHistoryThunk,
});

const PrintInvoiceSlice = createDynamicSlice({
  name: "PrintInvoiceSlice",
  thunk: PrintInvoiceThunk,
  resetActionName: "resetInvoice",
});

const PrintLabelSlice = createDynamicSlice({
  name: "PrintLabelSlice",
  thunk: PrintLabelThunk,
  resetActionName: "resetLabel",
});

const ApproveOrderSlice = createDynamicSlice({
  name: "ApproveOrderSlice",
  thunk: ApproveOrderThunk,
  resetActionName: "resetApproveOrder",
});

const ChangePendingAmountSlice = createDynamicSlice({
  name: "ChangePendingAmountSlice",
  thunk: PendingAmountThunk,
});

const WayuvegaSlice = createDynamicSlice({
  name: "WayuvegaSlice",
  thunk: WayuvegaThunk,
});

const OrderRevenueSlice = createDynamicSlice({
  name: "OrderRevenueSlice",
  thunk: OrderRevenueThunk,
  listMode: false,
});
const SettlementSlice = createDynamicSlice({
  name: "SettlementSlice",
  thunk: SettlementThunk,
  listMode: true,
});
const getSellerListingSlice = createDynamicSlice({
  name: "getSellerListingSlice",
  thunk: getSellerListingThunk,
});

const getStoresListingSlice = createDynamicSlice({
  name: "getStoresListingSlice",
  thunk: getStoresListingThunk,
});

const generateManifestSlice = createDynamicSlice({
  name: "generateManifestSlice",
  thunk: GenerateManifestThunk,
  resetActionName: "resetManifest",
});

const uploadBloodSampleReportSlice = createDynamicSlice({
  name: "uploadBloodSampleReportSlice",
  thunk: UploadBloodSampleReportThunk,
  resetActionName: "resetBloodSampleReport",
});

const getInvoicesByRefsSlice = createDynamicSlice({
  name: "getInvoicesByRefsSlice",
  thunk: getInvoicesByRefsThunk,
  resetActionName: "resetorderInvoice",
});


export const getSellerListingReducer = getSellerListingSlice.reducer;
export const getStoresListingReducer = getStoresListingSlice.reducer;
export const orderReducer = OrderSlice.reducer;
export const orderOverviewReducer = OrderOverviewSlice.reducer;
export const orderTransactionReducer = OrderTransactionSlice.reducer;
export const orderPaymentReducer = OrderPaymentSlice.reducer;
export const saveOrderRemarksReducer = SaveOrderRemarksSlice.reducer;
export const orderRemarkHistoryReducer = OrderRemarksHistorySlice.reducer;
export const orderInStoreReducer = OrderInStoreSlice.reducer;
export const orderShippingReducer = OrderShippingSlice.reducer;
export const changeStatusInStoreReducer = ChangeStatusInStoreSlice.reducer;
export const orderBarReducer = OrderBarSlice.reducer;
export const orderChangeStatusReducer = OrderChangeStatusSlice.reducer;
export const orderShipmentHistoryReducer = OrderShipmentHistorySlice.reducer;
export const prinntInvoiceReducer = PrintInvoiceSlice.reducer;
export const printLabelReducer = PrintLabelSlice.reducer;
export const approveOrderReducer = ApproveOrderSlice.reducer;
export const pendingAmountReduucer = ChangePendingAmountSlice.reducer;
export const { resetApproveOrder } = ApproveOrderSlice.actions;
export const { resetSaveOrderRemark } = SaveOrderRemarksSlice.actions;
export const { resetOrderChangeStatus } = OrderChangeStatusSlice.actions;
export const { resetChangeStatusInstore } = ChangeStatusInStoreSlice.actions;
export const { resetInvoice } = PrintInvoiceSlice.actions;
export const wayuvegaReducer = WayuvegaSlice.reducer;
export const orderRevenueReducer = OrderRevenueSlice.reducer;
export const settlementReducer = SettlementSlice.reducer;
export const { resetLabel } = PrintLabelSlice.actions;
export const generateManifestReducer = generateManifestSlice.reducer;
export const { resetManifest } = generateManifestSlice.actions;
export const uploadBloodSampleReportReducer = uploadBloodSampleReportSlice.reducer;
export const { resetBloodSampleReport } = uploadBloodSampleReportSlice.actions;
export const generatedInvoicesByRefsReducer = getInvoicesByRefsSlice.reducer;
export const { resetorderInvoice } = getInvoicesByRefsSlice.actions;
